import React from 'react'
import { useParams, Outlet } from 'react-router-dom'
import LoadableImporter from './loadable-importer'

export default function ContactsImport() {
  const params = useParams<{ listId?: string }>()

  return (
    <div>
      <LoadableImporter params={params} />
      <Outlet />
    </div>
  )
}
